import {
  BILLING_UNAVAILABLE_STATUS,
  EMPTY_BILLING_STATUS,
  hasProvisionedBillingStatus,
  normalizeBillingStatus,
  shouldRevalidateBillingStatus,
} from './billingStatusState';

export const resolveInitialBillingProviderState = (initialBillingStatus = null) => {
  const normalizedStatus = initialBillingStatus
    ? normalizeBillingStatus(initialBillingStatus)
    : EMPTY_BILLING_STATUS;

  return {
    billingStatus: normalizedStatus,
    initialized: Boolean(
      initialBillingStatus
      && !shouldRevalidateBillingStatus(normalizedStatus)
    ),
  };
};

export const shouldHydrateBillingProvider = ({
  onboardingComplete = false,
  initialized = false,
} = {}) => onboardingComplete && !initialized;

export const mergeSeededBillingStatus = ({
  previousBillingStatus = EMPTY_BILLING_STATUS,
  billingFromAuthMe = null,
} = {}) => {
  if (!billingFromAuthMe) {
    return {
      billingStatus: previousBillingStatus,
      initialized: false,
    };
  }

  const normalized = normalizeBillingStatus(billingFromAuthMe);
  return {
    billingStatus: { ...previousBillingStatus, ...normalized },
    initialized: !shouldRevalidateBillingStatus(normalized),
  };
};

export const resolveBillingRefreshFailureState = ({
  currentBillingStatus = EMPTY_BILLING_STATUS,
} = {}) => {
  const hasKnownGoodStatus = hasProvisionedBillingStatus(currentBillingStatus);
  return {
    billingStatus: hasKnownGoodStatus ? currentBillingStatus : BILLING_UNAVAILABLE_STATUS,
    initialized: true,
  };
};
